<template>
    <td>
        <div v-if="location?.specificLocation">
            {{ location.specificLocation }}
        </div>
    </td>
</template>
<script setup>
const props = defineProps({
    location: Object,
});
</script>
